<template>
  <div class="workoutZone__fields workoutZone__fields--action">
    <div
      class="workoutPlayToolbar workoutActionBindingCols"
      :class="{ 'workoutPlayToolbar--disabled': !preview.adaptationEditable }"
    >
      <div class="workoutPlayToolbar__col">
        <span class="workoutPlayToolbar__label">{{ fieldLabels.videoRepeatCount }}</span>
        <workout-number-stepper
          class="workoutPlayToolbar__stepper"
          :value="row.repeat_count"
          :min="0"
          :max="preview.repeatMax"
          :disabled="!preview.adaptationEditable"
          :aria-label="fieldLabels.videoRepeatCount"
          @input="onRepeatCount"
        />
      </div>

      <div class="workoutPlayToolbar__separator" aria-hidden="true" />

      <div class="workoutPlayToolbar__col">
        <span class="workoutPlayToolbar__label">{{ fieldLabels.configuredPlaySeconds }}</span>
        <span
          class="workoutPlayToolbar__total link-font-mono"
          :class="{ 'workoutPlayToolbar__total--active': hasActiveDuration }"
          :aria-live="preview.hasVideoDuration ? 'polite' : 'off'"
        >
          {{ preview.configuredPlayLabel }}
        </span>
      </div>

      <div class="workoutPlayToolbar__separator" aria-hidden="true" />

      <div class="workoutPlayToolbar__col">
        <span class="workoutPlayToolbar__label">{{ fieldLabels.restSeconds }}</span>
        <workout-number-stepper
          class="workoutPlayToolbar__stepper"
          :value="row.rest_seconds"
          :min="0"
          :max="maxRestSeconds"
          :disabled="restStepperDisabled"
          :aria-label="fieldLabels.restSeconds"
          @input="onRestSeconds"
        />
      </div>
    </div>

    <p v-if="!preview.hasVideoDuration" class="workoutZone__fieldHint workoutZone__fieldHint--warn">
      缺动作视频时长，请先保存动作 zip
    </p>
    <p
      v-else-if="!preview.adaptationEditable"
      class="workoutZone__fieldHint"
    >
      子资源信息未就绪，请稍候或刷新页面后再调整循环/休息
    </p>
    <p
      v-else-if="preview.mainSideMismatch"
      class="workoutZone__fieldHint"
    >
      {{ mismatchTip }}
    </p>
  </div>
</template>

<script>
import WorkoutNumberStepper from './WorkoutNumberStepper.vue'
import { WORKOUT_BINDING_FIELD_TIPS } from './workoutFormConstants'
import {
  MAX_REST_SECONDS,
  applyRepeatCountChange,
  applyRestSecondsChange,
  getLiveAdaptationPreview,
} from './workoutActionBindingCalculator'
import './workoutCollectionBinding.css'

export default {
  name: 'WorkoutActionBindingFields',
  components: { WorkoutNumberStepper },
  props: {
    row: { type: Object, required: true },
    fieldLabels: { type: Object, required: true },
    isLast: { type: Boolean, default: false },
    actionIndex: { type: Number, default: 0 },
    actionCount: { type: Number, default: 1 },
  },
  data() {
    return {
      maxRestSeconds: MAX_REST_SECONDS,
      mismatchTip: WORKOUT_BINDING_FIELD_TIPS.mainSideMismatch,
    }
  },
  computed: {
    preview() {
      return getLiveAdaptationPreview(this.row)
    },
    restStepperDisabled() {
      return (
        !this.preview.adaptationEditable || (this.isLast && this.actionCount > 1)
      )
    },
    hasActiveDuration() {
      return (
        this.preview.hasVideoDuration &&
        this.preview.configuredPlayLabel !== '0s' &&
        this.preview.configuredPlayLabel !== '—'
      )
    },
  },
  methods: {
    emitRow(nextRow) {
      this.$emit('change', nextRow)
    },
    rowOptions() {
      return {
        index: this.actionIndex,
        totalRows: this.actionCount,
      }
    },
    onRepeatCount(value) {
      this.emitRow(applyRepeatCountChange(this.row, value, this.rowOptions()))
    },
    onRestSeconds(value) {
      this.emitRow(applyRestSecondsChange(this.row, value, this.rowOptions()))
    },
  },
}
</script>

<style scoped>
.workoutPlayToolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--workout-binding-col-gap, 20px);
  width: fit-content;
  max-width: 100%;
}

.workoutPlayToolbar__col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: var(--workout-binding-col-width, 132px);
  min-width: 0;
}

.workoutPlayToolbar__stepper {
  width: 100%;
}

.workoutPlayToolbar__separator {
  flex: 0 0 auto;
  align-self: center;
  width: 1px;
  height: calc(var(--workout-binding-control-height, 32px) + 22px);
  margin-top: 22px;
  background: var(--link-line-strong, #e5dfd6);
}

.workoutPlayToolbar__label {
  font-size: 11px;
  font-weight: var(--link-font-semibold);
  color: var(--link-ink-muted);
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

.workoutPlayToolbar__total {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: var(--workout-binding-control-height, 32px);
  font-size: 15px;
  font-weight: var(--link-font-semibold);
  color: var(--link-ink-secondary, #4a4541);
  letter-spacing: 0.01em;
  text-align: center;
  white-space: nowrap;
}

.workoutPlayToolbar--disabled {
  opacity: 0.88;
}

.workoutPlayToolbar__total--active {
  color: var(--link-accent, #a67c52);
}
</style>
